export default __webpack_public_path__ + "static/media/Tevez.0ac746c6.jpg";